import { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../../constants/constants';
import NRShowMoreStyles from './NRShowMore.styles';
const { SHOW_MORE, SHOW_LESS } = CONSTANTS;
const useStyles = makeStyles(NRShowMoreStyles);

function NRShowMore({ items, itemsToShowByDefault = 10, openByDefault = false, maxReached, stateToRefresh }) {
  const theme = useTheme();
  const [showMore, setShowMore] = useState(openByDefault);
  const [showShowMoreLabel] = useState(items.length > itemsToShowByDefault);
  const [itemsToShow, setItemsToShow] = useState(items.slice(0, itemsToShowByDefault));
  const targetRef = useRef();

  const classes = useStyles();

  useEffect(() => {
    if (showMore) {
      setItemsToShow(items);
    } else {
      setItemsToShow(items.slice(0, itemsToShowByDefault));
    }
  }, [showMore, stateToRefresh]);

  return (
    <div className={classes.mainContainer}>
      <div ref={targetRef} className={classes.itemsContainer}>
        {itemsToShow}
      </div>
      {showMore && maxReached}
      {showShowMoreLabel && (
        <Button
          type="button"
          variant="text"
          aria-expanded={showMore}
          onClick={() => setShowMore(prev => !prev)}
          sx={{
            ...theme.typography.body2,
            marginTop: theme.spacing(1),
            textDecoration: 'underline',
            cursor: 'pointer',
            color: theme.palette.text.secondary,
            textTransform: 'none',
            minWidth: 0,
            padding: 0,
            justifyContent: 'flex-start'
          }}
        >
          {showMore ? SHOW_LESS : SHOW_MORE}
        </Button>
      )}
    </div>
  );
}
export default NRShowMore;
